export const regexPassword = /^(?!.*[\u00C0-\u01B0\u01C0-\u024F\u1E00-\u1EFF])^[^\s]*$/;

export const regexNationalId = /^\d{9}$|^\d{12}$/

export const regexPassportNo = /^[BCD]\d{7}$/

export const regexNoWhitespace = /^[^\s]*$/;

export const regexUsername = /^(?:[a-zA-Z0-9@_-]{3,16}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

export const regexPhoneNumberVN = /^(?:0(?:9[678]|8[678]|3[0123456789]|7[0123456789]|1[23456789]|2[23456789]|4[0123456789]|5[0123456789]|6[0123456789]|0[1-9])\d{7}|(?:0[1-9]{1}[0-9]{7,8}))$/;

export const regexFilename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

export const regexVietNameChar = /[\u00C0-\u01B0\u01C0-\u024F\u1E00-\u1EFF]/g;

export const regexTaxCode = /^\d{10,14}(-?\d{3})?$/;

export const regexBusinessTaxCode = /^(?:\d{10}|\d{12}|\d{10}-\d{3})$/;

export const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const regexMdvqhnsach = /^[0-9]{7,10}$/;



// WEBPACK FOOTER //
// ./src/utils/regex.js